module.exports = __webpack_public_path__ + "img/cart.7a021ade.svg";